import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../mutation-types';
import stockistApi from '../../../api/stockist';
import alertHelper from '../../../helpers/alert';

const defaultState = () => ({
	stockist: {
		stock_starterkit: 0,
		stock_ro: 0,
		total_selling_all: 0
	},
	stockistreview: {
		resume: {one: 0, two: 0, three: 0, four: 0, five: 0}
	},
	alerts: [],
	fieldErrors: {},
	step3Alert:[],
	step3AlertTitle:''
});

const state = defaultState();

const mutations = {
	Step3Eror(state, data) {
		if(typeof data == 'object'){
			state.step3Alert = Object.entries(data)
		} else {
			state.step3Alert = data
		}
	},
	Step3ErorTittle(state,data) {
		state.step3AlertTitle = data
	},
	Step3ErorTitleReset(state){
		state.step3AlertTitle = ''
	},
	Step3ErorReset(state) {
		state.step3Alert = []
	},
	detailRequestSuccess(state, data) {
		state.stockist = Object.assign({}, state.stockist, data);
	},
	reviewRequestSuccess(state, data) {
		state.stockistreview = Object.assign({}, state.stockistreview, data);
	},
	failed(state, { code, type, message }) {
		state.alerts = alertHelper.make(state.alerts, code, type, message);
	},
	removeAlert(state, id) {
		const index = Array.from(state.alerts).findIndex(it => it.id === id);

		if (index !== -1) {
			state.alerts.splice(index, 1);
		}
	},
	reset(state) {
		Object.assign(state, defaultState());
	},
};

const actions = {
	detail({ state, commit, dispatch }, code) {
		if (code === state.stockist.stockist_code) {
			return;
		}

		commit(PROGRESS_START, null, { root: true });

		stockistApi.detail(code).then(({ data: { data } }) => {
			commit('detailRequestSuccess', data);
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	getReview({ state, commit, dispatch }, code) {
		if (code === state.stockist.stockist_code) {
			return;
		}

		commit(PROGRESS_START, null, { root: true });

		stockistApi.review(code).then(({ data: { data } }) => {
			commit('reviewRequestSuccess', data);
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch((err) => {
			const { data } = err.response;
			dispatch('errorHandler', data);
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	errorHandler({ commit }, response ) {
		commit('failed', { code: 'error_response', type: 'error', message: response.message });
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
